(function () {
  'use strict';

  if (customElements.get('lead-form-place')) return;

  var ENDPOINT = 'https://api.mapbox.com/search/geocode/v6/forward';
  var TYPES = 'country,region,place,locality';
  var DEBOUNCE_MS = 200;
  var MIN_CHARS = 2;

  class LeadFormPlace extends HTMLElement {}

  LeadFormPlace.prototype.connectedCallback = function () {
    if (this._ready) return;
    this._ready = true;
    this.token = this.dataset.token || '';
    this.types = this.dataset.types || TYPES;
    this.proximity = this.dataset.proximity || '';
    this.input = this.querySelector('[data-place-input]');
    this.list = this.querySelector('[data-place-list]');
    this.country = this.querySelector('input[name="country"]');
    this.countryCode = this.querySelector('input[name="country_code"]');
    if (!this.input || !this.list || !this.token) return;

    this._results = [];
    this._active = -1;
    this._timer = null;
    this._controller = null;
    this._picked = '';

    this.input.addEventListener('input', this._onInput.bind(this));
    this.input.addEventListener('keydown', this._onKeydown.bind(this));
    this.input.addEventListener('blur', this._onBlur.bind(this));
    this.list.addEventListener('mousedown', this._onListMousedown.bind(this));
  };

  LeadFormPlace.prototype._url = function (q, autocomplete, limit) {
    return ENDPOINT +
      '?q=' + encodeURIComponent(q) +
      '&autocomplete=' + (autocomplete ? 'true' : 'false') +
      '&types=' + this.types +
      '&limit=' + limit +
      '&language=en' +
      (this.proximity ? '&proximity=' + encodeURIComponent(this.proximity) : '') +
      '&access_token=' + encodeURIComponent(this.token);
  };

  LeadFormPlace.prototype._fetch = function (q, autocomplete, limit) {
    if (this._controller) this._controller.abort();
    this._controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var opts = this._controller ? { signal: this._controller.signal } : {};
    return fetch(this._url(q, autocomplete, limit), opts)
      .then(function (res) { return res.ok ? res.json() : { features: [] }; })
      .then(function (body) { return (body && body.features) || []; });
  };

  LeadFormPlace.prototype._setCountry = function (feature) {
    var ctx = (feature && feature.properties && feature.properties.context) || {};
    var c = ctx.country || {};
    if (this.country) this.country.value = c.name || '';
    if (this.countryCode) this.countryCode.value = (c.country_code || '').toUpperCase();
  };

  LeadFormPlace.prototype._label = function (feature) {
    var p = feature.properties || {};
    return p.full_address || [p.name, p.place_formatted].filter(Boolean).join(', ');
  };

  LeadFormPlace.prototype._onInput = function () {
    var q = this.input.value.trim();
    if (q !== this._picked) {
      this._picked = '';
      this._setCountry(null);
    }
    clearTimeout(this._timer);
    if (q.length < MIN_CHARS) {
      this._close();
      return;
    }
    var self = this;
    this._timer = setTimeout(function () {
      self._fetch(q, true, 5).then(function (features) {
        if (self.input.value.trim() !== q) return;
        self._render(features);
      }).catch(function () {});
    }, DEBOUNCE_MS);
  };

  LeadFormPlace.prototype._render = function (features) {
    this._results = features;
    this._active = -1;
    this.list.innerHTML = '';
    if (!features.length || document.activeElement !== this.input) {
      this._close();
      return;
    }
    var baseId = this.list.id;
    for (var i = 0; i < features.length; i++) {
      var p = features[i].properties || {};
      var li = document.createElement('li');
      li.className = 'lead-form__place-option';
      li.id = baseId + '-' + i;
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');
      li.dataset.index = String(i);
      var main = document.createElement('span');
      main.className = 'lead-form__place-main';
      main.textContent = p.name || '';
      li.appendChild(main);
      if (p.place_formatted) {
        var sub = document.createElement('span');
        sub.className = 'lead-form__place-sub';
        sub.textContent = p.place_formatted;
        li.appendChild(sub);
      }
      this.list.appendChild(li);
    }
    this.list.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
  };

  LeadFormPlace.prototype._close = function () {
    this.list.hidden = true;
    this.list.innerHTML = '';
    this._active = -1;
    this.input.setAttribute('aria-expanded', 'false');
    this.input.removeAttribute('aria-activedescendant');
  };

  LeadFormPlace.prototype._highlight = function (i) {
    var opts = this.list.querySelectorAll('.lead-form__place-option');
    if (!opts.length) return;
    if (i < 0) i = opts.length - 1;
    if (i >= opts.length) i = 0;
    for (var k = 0; k < opts.length; k++) opts[k].setAttribute('aria-selected', k === i ? 'true' : 'false');
    this._active = i;
    this.input.setAttribute('aria-activedescendant', opts[i].id);
    opts[i].scrollIntoView({ block: 'nearest' });
  };

  LeadFormPlace.prototype._pick = function (i) {
    var f = this._results[i];
    if (!f) return;
    var label = this._label(f);
    this.input.value = label;
    this._picked = label;
    this._setCountry(f);
    this._close();
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  LeadFormPlace.prototype._onKeydown = function (e) {
    var open = !this.list.hidden;
    if (e.key === 'ArrowDown' && open) {
      e.preventDefault();
      this._highlight(this._active + 1);
    } else if (e.key === 'ArrowUp' && open) {
      e.preventDefault();
      this._highlight(this._active - 1);
    } else if (e.key === 'Enter' && open && this._active > -1) {
      e.preventDefault();
      this._pick(this._active);
    } else if (e.key === 'Escape' && open) {
      e.preventDefault();
      this._close();
    }
  };

  LeadFormPlace.prototype._onListMousedown = function (e) {
    var li = e.target.closest('.lead-form__place-option');
    if (!li) return;
    e.preventDefault();
    this._pick(parseInt(li.dataset.index, 10));
  };

  LeadFormPlace.prototype._onBlur = function () {
    clearTimeout(this._timer);
    this._close();
    var q = this.input.value.trim();
    if (!q || this._picked === q || (this.countryCode && this.countryCode.value)) return;
    var self = this;
    this._fetch(q, false, 1).then(function (features) {
      if (self.input.value.trim() !== q || self._picked === q) return;
      if (features[0]) self._setCountry(features[0]);
    }).catch(function () {});
  };

  customElements.define('lead-form-place', LeadFormPlace);
})();
